class UsersBrandAdminModalContainer {
  constructor(
    appErrorHandler,
    appEvents,
    appSessionCapabilities,
    brands,
    users,
    USERS_EVENTS,
  ) {
    'ngInject';

    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.appSessionCapabilities = appSessionCapabilities;
    this.brands = brands;
    this.users = users;
    this.USERS_EVENTS = USERS_EVENTS;

    this.removeOpenSubscription = this.appEvents.on(
      this.USERS_EVENTS.brandAdmin.open,
      (user) => this.openModal(user),
    );

    this.modalTitle = 'Admin settings';
    this.user = {};
    this.open = false;
    this.loading = false;
    this.error = '';
    this.settings = {
      brands: [],
    };
    this.lists = {
      main: brands.newList(),
      search: brands.newList(),
    };
    this.brandQuery = '';
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  openModal(user) {
    this.user = user;
    this.settings = {
      brands: [],
    };
    this.brandQuery = '';

    this.open = true;
    const name = this.user.hasName ? this.user.name : this.user.email;
    if (this.appSessionCapabilities.isBrandAdmin(false)) {
      this.modalTitle = `${name} - Admin settings`;
    } else {
      this.modalTitle = `${name} - Brand admin settings`;
    }

    const firstTime = this.user.permissions.brand_admin !== true;

    (firstTime ? Promise.resolve() : this._loadCurrentAssigments())
    .then(() => this._loadBrandsMainList());
  }
  closeModal() {
    this.open = false;
    this.appEvents.emit(this.USERS_EVENTS.brandAdmin.close);
  }
  searchBrands(text) {
    const query = text.toLowerCase();
    if (this.brandQuery !== query) {
      this.brandQuery = query;
      if (query) {
        this.lists.search.fetch(query)
        .catch((error) => {
          this.appErrorHandler.handle(error, 'There was an error loading the search results');
        });
      }
    }
  }
  saveModal(brands) {
    let result;
    if (this.loading) {
      result = this.$q.reject(new Error('The information are already being saved'));
    } else {
      this.loading = true;
      this.error = '';
      result = this.users.saveBrandAdminSettings(
        this.user.id,
        brands.map((brand) => brand.id),
      )
      .then(() => {
        this.appEvents.emit(this.USERS_EVENTS.brandAdmin.save);
        this.closeModal();
      })
      .catch((error) => {
        if (error.message) {
          this.error = error.message;
        } else {
          this.appErrorHandler.handle(error, 'There was an error while saving the settings');
        }
      })
      .then(() => {
        this.loading = false;
      });
    }

    return result;
  }
  _loadCurrentAssigments() {
    this.loading = true;
    return this.users.brandAdminSettings(this.user.id)
    .then((settings) => {
      this.settings = settings;
    })
    .catch((error) => {
      this.appErrorHandler.handle(
        error,
        'There was an error loading the information, please try again',
      );
      this.closeModal();
    })
    .then(() => {
      this.loading = false;
    });
  }
  _loadBrandsMainList() {
    return this.lists.main.items.length ?
      Promise.resolve() :
      this.lists.main
      .fetch()
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error loading the accounts');
      });
  }
}

export default {
  controller: UsersBrandAdminModalContainer,
  template: `
  <modal-wrapper
    ng-if="$ctrl.open"
    modal-title="$ctrl.modalTitle"
    on-close="$ctrl.closeModal()"
  >
    <users-brand-admin-form
      loading="$ctrl.loading"
      on-cancel="$ctrl.closeModal()"
      on-save="$ctrl.saveModal(brands)"

      brands="$ctrl.settings.brands"
      loading-brands="$ctrl.lists.main.fetching || $ctrl.lists.search.fetching"
      brands-results="
        $ctrl.brandQuery ?
        $ctrl.lists.search.items :
        $ctrl.lists.main.items
      "
      on-brands-search="$ctrl.searchBrands(text)"
    ></users-brand-admin-form>
  </modal-wrapper>
  `,
};
